import React from 'react';
import { IconComment } from '../../../../components/Icons';
import CommentsModule from './CommentsModule';
import { RightPanelModule } from '../../../components/NewTable/RightPanel/RightPanelContext';

/**
 * Comments Module Configuration
 *
 * Defines the static properties of the Comments module for the right panel
 */
const commentsModuleConfig = {
  id: 'comments',
  name: 'Comments',
  icon: <IconComment />,
  component: CommentsModule,
  enabled: false,
  expandEnabled: true,
  keyboardShortcut: 'c',
  order: 4,
  iconSize: 22,
};

export default commentsModuleConfig;
